import { PropagateLoader } from 'react-spinners';
import styled, { useTheme } from 'styled-components';

import { ThemeType } from '../../themeStyled';

interface LoaderProps {
	children?: React.ReactNode;
	loading: boolean;
}

const LoaderWrapper = styled.div`
	justify-content: center;
	align-items: center;
	display: flex;

	position: fixed;
	background: rgba(0, 0, 0, 0.3);
	width: 100%;
	height: 100%;
	z-index: 9998;
	top: 0;
	left: 0;
`;

export const Loader = (props: LoaderProps) => {
	const theme = useTheme() as ThemeType;

	return <LoaderWrapper>{props.loading ? <PropagateLoader color={theme.colors.erik.red} loading size={40} /> : <div>{props.children}</div>}</LoaderWrapper>;
};

export default Loader;
